import { BaseAction } from "../../../core/actions/BaseAction";
import { calculatePrice } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum, TrainTypeEnum, AncillaryStatusEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { isNolAncillary } from "../../../Lib/Utils/nolCard";
import { IBookedOffer, IBookingTypeTrip } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ICalculateAlreadyPaidAddonsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/GetAddonsParams";
import { IPaymentItemDetails } from "../../../Orchestrator/Types/Interface/IPayment";

export class CalculateAlreadyPaidAddonsAction extends BaseAction<
    IDefaultActionResult,
    ICalculateAlreadyPaidAddonsActionParams
> {
    override async run(): Promise<IDefaultActionResult | null> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail",
        };
        try {
            const { allBookedOfferWithoutExchange, allBookedTripWithoutExchange } = this.params!;
            let paymentSummary: any = {};
            // Flatten once: post-exchange the NOL product an ancillary references
            // can live on a sibling offer, not just the offer that owns it.
            const allProducts = allBookedOfferWithoutExchange.flatMap((o: IBookedOffer) => o?.products || []);
            allBookedOfferWithoutExchange.forEach((bookedOffer: IBookedOffer) => {
                const transformedMealOptions: IPaymentItemDetails[] = [];
                let bookTrip = allBookedTripWithoutExchange.find(d => d.id === bookedOffer.tripCoverage.coveredTripId)
                const allAncillaryForTrip = bookedOffer.ancillaries.filter(d => {
                    if (d.tripCoverage.coveredTripId !== bookTrip?.id || d.status === AncillaryStatusEnum.REFUNDED) return false;
                    // NOL passes ride the booking as ancillaries but belong to the
                    // End-to-end Journey flow — they must not be counted as an
                    // "already paid" addon credit in change-date / quick-exchange.
                    if (isNolAncillary(allProducts, d)) return false;
                    return true;
                })
                for (const ancillaries of allAncillaryForTrip) {
                    const productId = ancillaries.products[0].productId
                    const productDetails = bookedOffer.products.find(d => d.id === productId)
                    const transformedMeal: IPaymentItemDetails = {
                        amount: calculatePrice(ancillaries.price),
                        category: productDetails?.description || "",
                        description: productDetails?.description || "",
                    };
                    transformedMealOptions.push(transformedMeal);
                }

                const countAddons = transformedMealOptions.reduce((acc: Record<string, { amount: number, count: number }>, item: IPaymentItemDetails) => {
                    const categoryText = item?.category || ""
                    if (!acc[categoryText]) {
                        acc[categoryText] = { amount: 0, count: 0 };
                    }
                    acc[categoryText].amount += item.amount;
                    acc[categoryText].count += 1
                    return acc;
                }, {})
                const finalAddons = Object.keys(countAddons).map(category => {
                    return {
                        amount: countAddons[category].amount,
                        description: `${countAddons[category].count} ${category}`
                    }
                })
                let direction = bookTrip?.direction || ""
                direction = direction === TripTypeEnum.IN_BOUND ? TrainTypeEnum.inbound : TrainTypeEnum.outbound
                // paymentSummary[direction] = finalAddons
                const totalPrice = (finalAddons || []).reduce((price, item) => price += item.amount, 0)
                // paymentSummary.payment.total = totalPrice
                paymentSummary[direction] = totalPrice
            })
            updateRecoilState("changeTripAlreadyPaidAddonsAtom", paymentSummary);

            actionResult.status = "success";
            actionResult.data = paymentSummary
        } catch (error: any) {
            console.log("error : ", error.message)
            actionResult.message = error.message;
        } finally {
            return actionResult;
        }
    }
}

export const calculateAlreadyPaidAddonsAction = new CalculateAlreadyPaidAddonsAction();
